import React, { useEffect, useMemo, useRef, useState } from 'react';
import './SellersEngagementDocuments.scss';
import filterFactory, {
    FILTER_TYPES,
} from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import moment from 'moment';
import { useStateSelector } from '../../../../store/selectors';
import { EngagementDocument } from '../../../../slices/marketplace/timeline/models/engagement-document';
import { useDispatch } from 'react-redux';
import {
    TableFilter,
    TimelineDocumentsTableFilter,
} from '../../../../components/Table/models/table-filter';
import { GetEngagementDocuments } from '../../../../slices/marketplace/timeline/thunks/get-engagement-documents.thunk';
import { GetBuyerTimeline } from '../../../../slices/marketplace/timeline/thunks/get-buyer-timeline.thunk';
import { getApiErrorDetail } from '../../../../utils/getApiErrorDetail';
import {
    EngagementDocumentSource,
    EngagementDocumentSourceOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-source';
import {
    EngagementDocumentStatus,
    EngagementDocumentStatusOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-status';
import {
    EngagementDocumentCounterParty,
    EngagementDocumentCounterPartyOptions,
} from '../../../../slices/marketplace/timeline/models/enums/engagement-document-counter-party';
import {
    ActionDocumentType,
    DocumentDetailsTypesOptions,
} from '../../../../slices/marketplace/timeline/models/enums/action-document-type.enum';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';
import { DocumentDetails } from '../../../../slices/marketplace/timeline/models/document-details.model';
import createNotification from '../../../../utils/createNotification';
import EngagementDocumentPdfPreview from '../EngagementDocumentPdfPreviewModal/EngagementDocumentPdfPreviewModal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import { DocumentSignModal } from '../../../../components/DocumentSignModal/DocumentSignModal';
import { Button } from 'reactstrap';
import { TimelineEventStatus } from '../../../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import EngagementDocumentUploadModal from '../EngagementDocumentUploadModal/EngagementDocumentUploadModal';
import { EngagementBuyer } from '../../../../slices/marketplace/timeline/models/engagement-buyer.model';
import BuyerProfilePreviewPopup from '../../../../components/BuyerProfilePreviewPopup/BuyerProfilePreviewPopup';
import CollapsibleComponent from '../../../../components/Collapsible/CollapsibleComponent';
import { DocumentDetailsContentType } from '../../../../slices/marketplace/timeline/models/enums/document-details-content-type';
import { LevelOfService, isSfas } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import ContactSupportButton from '../../../ContactSupportButton/ContactSupportButton';
import { SupportContextEnum } from '../../../../support-portal/models/SupportContext';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import { EngagementProcessStatus } from '../../../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../../routing/path';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { useCurrentMarketplaceParty } from '../../../../custom-hooks/useCurrentMarketplaceParty';
import ProjectItemViewPopup from '../../ProjectItemViewPopup/ProjectItemViewPopup';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import ManualFileUploadPopup from './ManualFileUploadPopup/ManualFileUploadPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import EditDocumentNamePopup from './EditDocumentNamePopup/EditDocumentNamePopup';
import { GetTimelineById } from '../../../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { RemoveEngagementDocument } from '../../../../slices/marketplace/timeline/thunks/remove-engagement-document.thunk';
import { RestoreEngagementDocument } from '../../../../slices/marketplace/timeline/thunks/restore-engagement-document.thunk';
import { LinkedDataRequestProjectStatus } from '../../../../slices/marketplace/timeline/models/enums/linked-data-request-project-status.enum';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { NotificationFlag } from '../../../../components/NotificationFlag/NotificationFlag';
import { USER_ROLES } from '../../../../utils/constants';
import { MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION } from '../../../../utils/associateMembersConstants';
import { LoiFormsProcess, isLoiProcessCompleted } from '../../../../slices/marketplace/loi-comparison/models/loi-forms-process.model';
import LoiSubmissionInformationSupplementPopup from '../LoiSubmissionInformationSupplementPopup/LoiSubmissionInformationSupplementPopup';
import { isBuyerDdNdaAwaitingSignature } from '../../../../slices/marketplace/timeline/utils/dd-nda-document';
import { MarkDdNdaExecuted } from '../../../../slices/marketplace/timeline/thunks/mark-dd-nda-executed.thunk';
import MarkDdNdaExecutedPopup from './MarkDdNdaExecutedPopup/MarkDdNdaExecutedPopup';
import { GetLoiSigningStatus } from '../../../../slices/marketplace/loi-signing/thunks/get-loi-signing-status.thunk';
import { SignLoi } from '../../../../slices/marketplace/loi-signing/thunks/sign-loi.thunk';
import { LoiSigningStatus } from '../../../../slices/marketplace/loi-signing/models/loi-signing-status.model';
import { LoiSignersList } from '../../../../components/LoiSignersList/LoiSignersList';

interface EngagementDocumentWithSelect extends EngagementDocument {
    isSelected: boolean;
    isDisabled: boolean;
    isToApproveAgain?: boolean;
}

interface SellersEngagementDocumentsSectionProps {
    timelineId: number;
    engagementDocumenstSection: DocumentSection;
    buttonsSection: React.JSX.Element;
    isSelectModeEnabled: boolean;
    selectedDocumentsIds: string[];
    onDocumentSelected: (documentId: string) => void;
    isAdminView: boolean;
    downloadableDocDetailsFilterCondition: (
        t: DocumentDetails | EngagementDocument
    ) => boolean;
    isGettingForSign: boolean;
    setIsGettingForSign: (isGettingForSign: boolean) => void;
    preSelectedDocumentId?: string;
    resetPreSelectedDocumentId?(): void;
    documentsToApproveAgain?: string[];
    // [#1314 review] The catch-up the Seller has open: an approval acts on it alone.
    catchUpTimelineId?: number;
    documentIdToSign?: string | null;
    resetDocumentIdToSign?(): void;
    setDownloadableDocumentsIds: (ids: string[]) => void;
    isReadOnly?: boolean;
    onLoaded?: () => void;
    documentsReloadCount?: number;
    reloadDocuments?(): void;
}

const SellersEngagementDocumentsSection = (
    props: SellersEngagementDocumentsSectionProps
) => {
    const axios = useStateSelector((t) => t.core.axios);
    const navigate = useNavigate();
    const party = useCurrentMarketplaceParty(props.timelineId);
    const isAdmin = party === TimelineParty.VetValue;
    const isBroker = party === TimelineParty.Broker;
    const isObserver = party === TimelineParty.Observer;
    const summary = useStateSelector((t) => t.userSummary.summary);
    const isSellerTeamMemberWithPracticeDataAndDocsPermission =
        summary?.roleId === USER_ROLES.PRACTICE_SECONDARY_USER &&
        ((summary?.associateMember ?? []) as any[]).some(
            (am) =>
                am.associateMemberMarketplaceMappings &&
                (am.associateMemberMarketplaceMappings as any[]).some(
                    (mapping) =>
                        mapping.isSellerSide &&
                        mapping.engagementId === props.timelineId &&
                        mapping.currentSellerTMPermissions &&
                        (mapping.currentSellerTMPermissions as any[]).some(
                            (p) =>
                                p === MARKETPLACE_SELLER_TEAM_MEMBER_PERMISSION.PracticeDataAndDocs
                        )
                )
        );

    const engagementDocuments = useStateSelector(
        (t) =>
            t.timelines.engagementDocumentsTables[
                props.engagementDocumenstSection.id
            ]
    );
    const timeline = useStateSelector((t) => t.timelines.currentTimeline);
    const dispatch = useDispatch() as any;
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(
        props.preSelectedDocumentId
    );

    const [documents, setDocuments] = useState<EngagementDocumentWithSelect[]>(
        []
    );
    // [#1299 F10] The catch-up's documents to approve again can load after the rows, and the remote table re-renders a
    // cell only when its row changes - so the flag travels in the row (as F1's docket rows do).
    const documentsToApproveAgainKey = (props.documentsToApproveAgain ?? []).join(',');
    const rows = useMemo(() => {
        const toApproveAgain = new Set(documentsToApproveAgainKey.split(',').filter((id) => !!id));
        return documents.map((document) => ({ ...document, isToApproveAgain: toApproveAgain.has(document.id) }));
    }, [documents, documentsToApproveAgainKey]);
    const [page, setPage] = useState(1);
    const [totalSize, setTotalSize] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(5000);

    const [currentSort, setCurrentSort] = useState<TableFilter>(
        new TableFilter({ filters: [], logic: '' }, page, sizePerPage, {
            dir: 'asc',
            field: 'id',
        })
    );

    const [isProjectItemViewPopupVisible, setIsProjectItemViewPopupVisible] =
        useState(false);
    const [linkedProjectToView, setLinkedProjectToView] =
        useState<LinkedDataRequestProject>();
    const [questionnaireDocument, setQuestionnaireDocument] =
        useState<EngagementDocument>();

    const [isBuyerProfilePopupVisible, setIsBuyerProfilePopupVisible] =
        useState(false);
    const [selectedEngagedBuyer, setSelectedEngagedBuyer] =
        useState<EngagementBuyer>(null);

    const [isDocModalVisible, setIsDocModalVisible] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [documentToSign, setDocumentToSign] = useState<number>();
    const [documentToSignId, setDocumentToSignId] = useState<string>();
    const [loiSigningDocumentId, setLoiSigningDocumentId] = useState<string>();
    const [loiSigningStatuses, setLoiSigningStatuses] = useState<
        Record<string, LoiSigningStatus>
    >({});
    const [documentToUploadFile, setDocumentToUploadFile] = useState<string>();
    const [manualDocumentToUpdate, setManualDocumentToUpdate] =
        useState<string>();
    const [isApprovalPopupVisible, setIsApprovalPopupVisible] = useState(false);
    const [documentApprovalPopupHeader, setDocumentApprovalPopupHeader] =
        useState('');
    const [isMultiDocumentApproval, setIsMultiDocumentApproval] =
        useState(false);
    const singleDocBody =
        "By clicking 'Confirm Approval', I acknowledge that I have reviewed this document " +
        'and authorize its distribution to the selected buyers.';
    const multiDocAndDfmBody =
        "By clicking 'Confirm Approval', I confirm that I have reviewed all documents in this section, " +
        'including the detailed financial model and employee roster maps, ' +
        'and I authorize their distribution to the selected buyers.';

    const [isDocConfirming, setIsDocConfirming] = useState(false);
    const [isNavigatingToFeedback, setIsNavigatingToFeedback] = useState(false);
    const isInitialTableLoad = useRef(true);
    const [documentWithFeedbackId, setDocumentWithFeedbackId] =
        useState<string>();
    const [documentToEditName, setDocumentToEditName] =
        useState<EngagementDocument>();
    const [documentToRemove, setDocumentToRemove] =
        useState<EngagementDocument>();
    const [isRemoveConfirmationVisible, setIsRemoveConfirmationVisible] =
        useState(false);
    const [isProcessingRemove, setIsProcessingRemove] = useState(false);
    const [documentToRestore, setDocumentToRestore] =
        useState<EngagementDocument>();
    const [isRestoreConfirmationVisible, setIsRestoreConfirmationVisible] =
        useState(false);
    const [isProcessingRestore, setIsProcessingRestore] = useState(false);
    const [loiSupplementPopupLoiFormId, setLoiSupplementPopupLoiFormId] =
        useState<string | null>(null);
    const [markExecutedTargetRow, setMarkExecutedTargetRow] =
        useState<EngagementDocument>();
    const [isMarkExecutedPopupVisible, setIsMarkExecutedPopupVisible] =
        useState(false);
    const [isMarkingDdNdaExecuted, setIsMarkingDdNdaExecuted] =
        useState(false);
    const [
        isAdminExecutedInfoPopupVisible,
        setIsAdminExecutedInfoPopupVisible,
    ] = useState(false);

    // [#1842 O5] An offer a resume archived or ended is no longer signed here: its LOI is not a live step's document,
    // and asking for its signing status answered 404 (an error on the page) after the resume.
    const loiExecutedDocumentIdsKey = (
        timeline?.engagementData?.loiFormsProcesses ?? []
    )
        .filter((p: LoiFormsProcess) => !p.archiveSectionId && !p.isEndedByAResume)
        .map((p: LoiFormsProcess) => p.executedDocumentDetailsId)
        .filter((id: string) => !!id)
        .join(',');

    const loadLoiSigningStatuses = () => {
        if (!props.engagementDocumenstSection.isLoiSection || !loiExecutedDocumentIdsKey || isBroker || isObserver) {
            return;
        }
        loiExecutedDocumentIdsKey.split(',').forEach((documentDetailsId) => {
            dispatch(
                GetLoiSigningStatus({
                    engagementId: props.timelineId,
                    documentDetailsId,
                })
            )
                .unwrap()
                .then((status: LoiSigningStatus) => {
                    setLoiSigningStatuses((current) => ({
                        ...current,
                        [documentDetailsId]: status,
                    }));
                })
                .catch((): void => undefined);
        });
    };

    const startLoiSigning = (documentDetailsId: string) => {
        setLoiSigningDocumentId(documentDetailsId);
        props.setIsGettingForSign(true);
        dispatch(
            SignLoi({ engagementId: props.timelineId, documentDetailsId })
        )
            .unwrap()
            .then((signDocumentsId: number) => {
                setDocumentToSign(signDocumentsId);
            })
            .catch((): void => undefined)
            .finally(() => {
                props.setIsGettingForSign(false);
                setLoiSigningDocumentId(undefined);
            });
    };

    useEffect(() => {
        loadLoiSigningStatuses();
    }, [loiExecutedDocumentIdsKey]);

    useEffect(() => {
        if (documentToSignId) {
            getDocumentToSign(documentToSignId);
        }
    }, [documentToSignId]);

    useEffect(() => {
        if (
            props.documentIdToSign &&
            documents.some((d) => d?.id === props.documentIdToSign)
        ) {
            setDocumentToSignId(props.documentIdToSign);
            props.resetDocumentIdToSign?.();
        }
    }, [props.documentIdToSign, documents]);

    useEffect(() => {
        if (
            documents &&
            selectedDocumentId &&
            documents.some((d) => d?.id === selectedDocumentId)
        ) {
            setIsExpanded(true);
        }
    }, [props.preSelectedDocumentId, documents]);

    // The collapsed section body stays mounted (keepMounted), so a document
    // flag may only self-remove once the section is expanded. Rendered inside
    // table cell formatters — the matching columns pass isExpanded through
    // formatExtraData so the cells re-render when it changes.
    const renderDocumentNotificationFlag = (
        eventCode: string,
        isSectionExpanded: boolean
    ) =>
        isSectionExpanded ? (
            <NotificationFlag eventCode={eventCode} includePrefix={true} />
        ) : (
            <NotificationFlag
                eventCode={eventCode}
                includePrefix={true}
                doNotRemove
            />
        );

    useEffect(() => {
        if (props.isGettingForSign) {
            setDocuments(
                documents.map((doc) => ({ ...doc, isDisabled: true }))
            );
        } else {
            setDocuments(
                documents.map((doc) => ({ ...doc, isDisabled: false }))
            );
        }
    }, [props.isGettingForSign]);

    useEffect(() => {
        const documentsCopy = documents.map((doc) => {
            return {
                ...doc,
                isSelected: props.selectedDocumentsIds.includes(doc?.id),
            };
        });
        setDocuments(documentsCopy);
    }, [props.selectedDocumentsIds]);

    useEffect(() => {
        resetHighlighting();
    }, []);


    const resetHighlighting = () => {
        setTimeout(() => {
            props.resetPreSelectedDocumentId();
            setSelectedDocumentId(null);
        }, 2000);
    };

    const fetchEngagementDocuments = async (sort?: TableFilter) => {
        await dispatch(
            GetEngagementDocuments({
                timelineId: props.timelineId,
                sectionId: props.engagementDocumenstSection.id,
                filterParams: {
                    ...(sort ?? currentSort),
                    pageSize: sizePerPage,
                    pageNumber: page,
                },
            })
        );
    };

    const fetchEngagement = async () => {
        await dispatch(
            GetTimelineById({ id: props.timelineId, isTemplate: false })
        );
    };

    const initiate = async () => {
        await fetchEngagementDocuments();
        props.onLoaded?.();
    };

    useEffect(() => {
        initiate().then();
    }, []);

    // [#1842 task 9] The rows are fetched on mount and on a sort only. A document added, changed or deleted by hand
    // may sit in any section, so every section fetches its rows again.
    useEffect(() => {
        if (props.documentsReloadCount) {
            fetchEngagementDocuments(currentSort).then();
        }
    }, [props.documentsReloadCount]);

    useEffect(() => {
        props.setDownloadableDocumentsIds(
            (engagementDocuments?.engagementDocuments ?? [])
                .filter((doc) =>
                    props.downloadableDocDetailsFilterCondition(doc)
                )
                .map((doc) => doc?.id)
        );
        if (engagementDocuments) {
            setDocuments(
                engagementDocuments.engagementDocuments as Array<EngagementDocumentWithSelect>
            );
            setPage(engagementDocuments.pageNumber);
            setTotalSize(engagementDocuments.totalItems);
            setSizePerPage(engagementDocuments.pageSize);
        }
    }, [engagementDocuments]);

    const getEventForDocument = (documentId: string) =>
        timeline.events.find(
            (event) => event.linkedAction?.referenceItemId === documentId
        );

    const getPdfUrl = (docId: string) => {
        axios
            .get(
                `/api/marketplace/engagements/${props.timelineId}/documentsDetails/${docId}`
            )
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while getting Document',
                        'error'
                    );
                    return;
                }
                setPdfUrl(response.data);
                setIsDocModalVisible(true);
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while getting Document',
                    'error'
                );
            });
    };

    const defaultSorted: [{ dataField: any; order: any }] = [
        {
            dataField: 'name',
            order: 'asc',
        },
    ];

    const handleTableChange = (_type: any, newState: any) => {
        if (isInitialTableLoad.current) {
            isInitialTableLoad.current = false;
            return;
        }
        const { page, sizePerPage, sortField, sortOrder } = newState;
        const updatedPostObj = new TimelineDocumentsTableFilter(
            { filters: [], logic: '' },
            page,
            sizePerPage,
            { dir: sortOrder, field: sortField }
        );

        const arrayOfObj = Object.entries(newState.filters).map((e) => ({
            [e[0]]: e[1],
        }));

        if (arrayOfObj.length > 0) {
            arrayOfObj.forEach((element) => {
                let key = Object.keys(element);

                let values = newState.filters[key.toString()];

                if (
                    values.filterType != FILTER_TYPES.DATE ||
                    values.filterVal.date != null
                ) {
                    let obj = {
                        Field: key[0],
                        Operator:
                            values.filterType == FILTER_TYPES.DATE ||
                            values.filterType == FILTER_TYPES.SELECT
                                ? 'eq'
                                : 'contains',
                        Value:
                            values.filterType == FILTER_TYPES.DATE
                                ? moment(values.filterVal.date).format(
                                      'MM.DD.YYYY'
                                  )
                                : values.filterVal,
                    };

                    updatedPostObj.filter.filters.push(obj);
                }
            });
        }

        setCurrentSort(updatedPostObj);

        fetchEngagementDocuments(updatedPostObj);
    };

    const getDocumentToSign = (documentId: string) => {
        props.setIsGettingForSign(true);
        axios
            .post(
                `/api/marketplace/engagements/${props.timelineId}/documents/${documentId}/sign`,
                []
            )
            .then((response) => {
                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while getting Document',
                        'error'
                    );
                    return;
                }
                setDocumentToSign(response.data);
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while getting Document',
                    'error'
                );
            })
            .finally(() => {
                props.setIsGettingForSign(false);
                setDocumentToSignId(undefined);
            });
    };

    const fetchDocument = async (documentId: string) => {
        const queryParams = `documentDetailsIds=${documentId}`;
        const response = await axios.get(
            `/api/marketplace/engagements/${timeline.id}/download-documents?${queryParams}`,
            {
                responseType: 'blob',
            }
        );
        return response;
    };

    const downloadFile = async (engagementDocument: EngagementDocument) => {
        const response = await fetchDocument(engagementDocument.id);
        if (response.status !== 200) {
            createNotification(
                'An unexpected error occurred while downloading document',
                'error'
            );
            return;
        }
        const fileName = engagementDocuments.engagementDocuments.find(
            (doc) => doc.id == engagementDocument.id
        )?.fileName ?? engagementDocument.fileName;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const confirmDocumentWithFeedback = (docId: string) => {
        setIsDocConfirming(true);
        const onTheCatchUp = props.catchUpTimelineId
            ? `?catchUpTimelineId=${props.catchUpTimelineId}`
            : '';
        axios
            .post(
                `/api/Marketplace/Engagements/${props.timelineId}/${docId}/confirm-engagement-document${onTheCatchUp}`
            )
            .then((response) => {
                if (response.status === 200) {
                    fetchEngagement();
                    fetchEngagementDocuments(currentSort);
                    // [#1314 review, O4] The catch-up's own steps changed: read it again, so the row loses its Approve
                    // and the step card its "Review & Approve" without a reload.
                    if (props.catchUpTimelineId) {
                        dispatch(
                            GetBuyerTimeline({
                                engagementId: props.timelineId,
                                timelineId: props.catchUpTimelineId,
                            })
                        );
                    }
                    createNotification(
                        'Document approved successfully',
                        'success'
                    );
                    return;
                }

                createNotification(
                    'Some unexpected error occurred while approving document.',
                    'error'
                );
            })
            .catch((error) => {
                // [2.17.3 K1] A refusal (422) says why, e.g. "Several catch-ups are waiting for this step."
                createNotification(
                    (error?.response?.status === 422 && getApiErrorDetail(error)) ||
                        'Some unexpected error occurred while approving document.',
                    'error'
                );
            })
            .finally(() => {
                setIsDocConfirming(false);
            });
    };

    const showRemoveConfirmation = (row: EngagementDocument) => {
        setDocumentToRemove(row);
        setIsRemoveConfirmationVisible(true);
    };

    const handleRemoveDocument = async () => {
        if (!documentToRemove) {
            return;
        }
        setIsProcessingRemove(true);
        try {
            await dispatch(
                RemoveEngagementDocument({
                    timelineId: props.timelineId,
                    documentId: documentToRemove.id,
                })
            ).unwrap();
            await fetchEngagementDocuments(currentSort);
            await fetchEngagement();
            createNotification('Document removed successfully', 'success');
            setIsRemoveConfirmationVisible(false);
            setDocumentToRemove(undefined);
        } catch {
            // The remove thunk already surfaces an error notification.
        } finally {
            setIsProcessingRemove(false);
        }
    };

    const showRestoreConfirmation = (row: EngagementDocument) => {
        setDocumentToRestore(row);
        setIsRestoreConfirmationVisible(true);
    };

    const handleRestoreDocument = async () => {
        if (!documentToRestore) {
            return;
        }
        setIsProcessingRestore(true);
        try {
            await dispatch(
                RestoreEngagementDocument({
                    timelineId: props.timelineId,
                    documentId: documentToRestore.id,
                })
            ).unwrap();
            await fetchEngagementDocuments(currentSort);
            await fetchEngagement();
            createNotification('Document restored successfully', 'success');
            setIsRestoreConfirmationVisible(false);
            setDocumentToRestore(undefined);
        } catch {
            // The restore thunk already surfaces an error notification.
        } finally {
            setIsProcessingRestore(false);
        }
    };

    const openMarkDdNdaExecutedPopup = (row: EngagementDocument) => {
        setMarkExecutedTargetRow(row);
        setIsMarkExecutedPopupVisible(true);
    };

    const closeMarkDdNdaExecutedPopup = () => {
        setIsMarkExecutedPopupVisible(false);
        setMarkExecutedTargetRow(undefined);
    };

    const handleMarkDdNdaExecuted = async (file?: File) => {
        if (!markExecutedTargetRow) {
            return;
        }
        setIsMarkingDdNdaExecuted(true);
        try {
            await dispatch(
                MarkDdNdaExecuted({
                    engagementId: props.timelineId,
                    buyerId: markExecutedTargetRow.engagementBuyerId,
                    file,
                })
            ).unwrap();
            await fetchEngagementDocuments(currentSort);
            await fetchEngagement();
            createNotification(
                'Document marked as executed successfully',
                'success'
            );
            closeMarkDdNdaExecutedPopup();
        } catch {
            // The thunk already surfaces an error notification.
        } finally {
            setIsMarkingDdNdaExecuted(false);
        }
    };

    useEffect(() => {
        const mappedDocuments = documents.map((doc) => {
            return {
                ...doc,
                isSelected: false,
            };
        });
        setDocuments(mappedDocuments);
    }, [props.isSelectModeEnabled]);

    const closeBuyerProfile = () => {
        setIsBuyerProfilePopupVisible(false);
        setSelectedEngagedBuyer(null);
    };

    const getQuestionnaireButton = (row: EngagementDocumentWithSelect) => {
        return (
            <Button
                onClick={() => {
                    const project =
                        timeline.engagementData.dataRequestProjects.find(
                            (p) => p.id === row.linkedProjectId
                        );
                    if (
                        project.status ===
                        LinkedDataRequestProjectStatus.Completed
                    ) {
                        updateDataRequestProjectStatus(
                            project.id,
                            LinkedDataRequestProjectStatus.InProgress
                        );
                    }
                    navigate(`${window.location.pathname}?tab=6`, {
                        state: {
                            projectId: project.dataRequestProjectId,
                            questionnaireId: row.questionnaireId,
                        },
                    });
                }}
                className="btn btn-primary"
                color="primary">
                Edit
            </Button>
        );
    };

    const updateDataRequestProjectStatus = (
        projectId: string,
        status: LinkedDataRequestProjectStatus
    ) => {
        axios
            .put(
                `/api/Marketplace/Engagements/${props.timelineId}/DataRequests/${projectId}/status`,
                status,
                {
                    headers: { 'Content-type': 'application/json' },
                }
            )
            .then((response) => {
                if (response.status !== 200) {
                    return;
                }
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while updating the status.',
                    'error'
                );
            });
    };

    const navigateToDocumentDiscussion = async (
        commsId: number,
        row: EngagementDocumentWithSelect
    ) => {
        if (!commsId || isNavigatingToFeedback) {
            return;
        }
        setIsNavigatingToFeedback(true);
        try {
            let discussionId = row.brokerChatDiscussionId;
            if (!row.brokerChatDiscussionId) {
                discussionId = await createDiscussionForDocument(
                    row.id,
                    commsId,
                    row.name,
                    `Document discussion: ${row.name}`
                );
            }
            if (!discussionId) {
                createNotification('Failed to create discussion', 'error');
                return;
            }
            navigate(
                `${paths.venues.connect.engagement(timeline.id)}?tab=${8}&subtab=${1}`,
                {
                    state: {
                        discussionId: discussionId,
                    },
                }
            );
        } finally {
            setIsNavigatingToFeedback(false);
        }
    };

    const createDiscussionForDocument = async (
        docId: string,
        commsId: number,
        name: string,
        description: string
    ) => {
        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${timeline.id}/documents/${docId}/Comms/${commsId}`,
                {
                    name: name,
                    description: description,
                    isRemovable: false,
                }
            );
            if (response && response.status === 200) {
                return response.data;
            } else {
                const message = response?.data?.title;
                createNotification(message || '', 'error');
                return null;
            }
        } catch (e) {
            createNotification(
                'An error occurred while creating discussion',
                'error'
            );
            return null;
        }
    };

    const getActionButtons = (
        cellContent: EngagementDocumentStatus,
        row: EngagementDocumentWithSelect
    ) => {
        const isDocWithFeedback =
            row.type === ActionDocumentType.DocumentWithFeedback;
        const isPipDocument =
            (row.contentType === DocumentDetailsContentType.PipOrPiq &&
                row.source === EngagementDocumentSource.AdminUpload) ||
            row.source === EngagementDocumentSource.BrokerUpload;
        const isPiqDocument =
            row.contentType === DocumentDetailsContentType.PipOrPiq &&
            row.source === EngagementDocumentSource.Questionnaire;
        const isFinancialModel =
            row.contentType === DocumentDetailsContentType.FinancialModel;
        const isMaster = row?.id === row.masterDocumentId;
        // [#1299 review] The catch-up asks for the same documents to be approved again, unchanged - a questionnaire PIQ
        // included, whose pending changes the first approval cleared.
        const isToApproveAgain = !!row.isToApproveAgain;
        const isMultiDoc =
            (isPipDocument || isFinancialModel) &&
            !!row.additionalVersionIds &&
            row.additionalVersionIds.length > 0;
        const isBrokerAssignedAndIsActive =
            !!timeline.engagementProcess?.broker &&
            timeline.engagementProcess?.broker?.isActive;

        const event = getEventForDocument(row?.id);
        const showUpdateFileBrokerBtn =
            isBroker &&
            ((row.counterParty === EngagementDocumentCounterParty.Seller &&
                row.type == ActionDocumentType.DocumentWithFeedback &&
                (isPipDocument || isFinancialModel)) ||
                row.isManualDocument);
        const showUpdateFileAdminBtn =
            isAdmin &&
            row.counterParty === EngagementDocumentCounterParty.Seller &&
            (((row.type == ActionDocumentType.Downloadable ||
                row.type == ActionDocumentType.Readonly) &&
                event?.status !== TimelineEventStatus.Completed) ||
                (row.type == ActionDocumentType.DocumentWithFeedback &&
                    row.source !== EngagementDocumentSource.Questionnaire));

        const getPiqApproveButtonText = (row: EngagementDocumentWithSelect) =>
            row.questionnaireId &&
            documents.find(
                (d) =>
                    d.questionnaireId === row.questionnaireId &&
                    d.questionnaireSnapshotId
            )
                ? 'Post Update to Buyers'
                : 'Approve';

        const shouldShowApproveButton = () => {
            if (isDocWithFeedback && isMaster) {
                if (
                    row.source === EngagementDocumentSource.AdminUpload ||
                    row.source === EngagementDocumentSource.BrokerUpload
                ) {
                    if (!row.fileUrl) return false;
                    if (
                        row.additionalVersionIds &&
                        row.additionalVersionIds.length > 0
                    ) {
                        const additionalDocs = documents.filter((d) =>
                            row.additionalVersionIds.includes(d.id)
                        );
                        if (additionalDocs.some((d) => !d.fileUrl))
                            return false;
                    }
                    return true;
                }
                if (row.source === EngagementDocumentSource.Questionnaire) {
                    if (!row.linkedProjectId || !row.questionnaireId)
                        return false;
                    return true;
                }
                return false;
            }
            return false;
        };

        // [#1303] A document in a Pre-suspension Archive is history and is not signed there.
        return cellContent === EngagementDocumentStatus.RequiresAction &&
            row.type === ActionDocumentType.ForSign &&
            row.counterParty !== EngagementDocumentCounterParty.Buyer &&
            !props.engagementDocumenstSection?.isArchive &&
            !isAdmin &&
            !isBroker ? (
            <ButtonLoader
                key={row?.id}
                buttonText="Execute Document"
                onClick={() => setDocumentToSignId(row?.id)}
                isLoading={
                    documentToSignId === row?.id && props.isGettingForSign
                }
                loaderButtonText="Execute Document"
                disabled={row.isDisabled}
                className={'btn btn-primary execute-document-button'}
            />
        ) : showUpdateFileAdminBtn || showUpdateFileBrokerBtn ? (
            <Button
                onClick={() =>
                    row.isManualDocument
                        ? setManualDocumentToUpdate(row?.id)
                        : setDocumentToUploadFile(row?.id)
                }
                className="btn btn-primary"
                color="primary">
                {row.isPrepared ? 'Update File' : 'Upload File'}
            </Button>
        ) : (cellContent === EngagementDocumentStatus.RequiresAction || isToApproveAgain) &&
          isDocWithFeedback &&
          (!isPiqDocument || row.hasPendingChanges || isToApproveAgain) &&
          !isAdmin &&
          !isBroker ? (
            <div className="feedback-buttons-container">
                {shouldShowApproveButton() ? (
                    <>
                        <Button
                            onClick={() => {
                                const popupHeader = isFinancialModel
                                    ? 'Financial Model Approval'
                                    : isPipDocument
                                      ? 'Practice Information Package Approval'
                                      : isPiqDocument
                                        ? 'Practice Information Questionnaire Approval'
                                        : 'Document Approval';
                                setDocumentApprovalPopupHeader(popupHeader);
                                setIsMultiDocumentApproval(isMultiDoc);
                                setDocumentWithFeedbackId(row?.id);
                                setIsApprovalPopupVisible(true);
                            }}
                            className="btn btn-primary"
                            color="primary">
                            {isPiqDocument
                                ? getPiqApproveButtonText(row)
                                : 'Approve'}
                        </Button>
                    </>
                ) : (
                    []
                )}
                {row.source === EngagementDocumentSource.Questionnaire
                    ? getQuestionnaireButton(row)
                    : []}
                {(timeline.levelOfService ==
                    LevelOfService.FullServiceBrokerage ||
                    isSfas(timeline.levelOfService)) &&
                isBrokerAssignedAndIsActive &&
                !isPiqDocument &&
                isMaster ? (
                    <Button
                        onClick={() =>
                            navigateToDocumentDiscussion(
                                timeline.engagementProcess?.broker
                                    ?.brokerChatId,
                                row
                            )
                        }
                        disabled={isNavigatingToFeedback}
                        className="btn btn-primary feedback-button"
                        color="primary">
                        Provide Feedback
                    </Button>
                ) : timeline.levelOfService ==
                      LevelOfService.DiscountBrokerage &&
                  !isPiqDocument &&
                  isMaster ? (
                    <ContactSupportButton
                        supportContext={SupportContextEnum.Marketplace}
                        buttonType="button"
                        buttonText="Provide Feedback"
                        hideIcon
                    />
                ) : (
                    []
                )}
            </div>
        ) : row.source === EngagementDocumentSource.Questionnaire &&
          !row.questionnaireSnapshotId ? (
            getQuestionnaireButton(row)
        ) : (
            <></>
        );
    };

    const isQuestionnaireSnapshot = (row: EngagementDocument) => {
        return row.isManualDocument && row.questionnaireSnapshotId;
    };

    const getLoiDocumentColumns = () => {
        const loiFormsProcesses = timeline.engagementData?.loiFormsProcesses ?? [];
        const hasPreparedSigners = Object.values(loiSigningStatuses).some(
            (status) => status.isPrepared && status.signers?.length > 0
        );
        return [
            {
                dataField: 'datePosted',
                text: 'Submission Date',
                sort: true,
                headerStyle: { minWidth: '180px' },
                style: { minWidth: '180px' },
                formatter: (cellContent: Date) => (
                    <div>{cellContent ? moment(cellContent).format('M/D/YYYY') : 'NA'}</div>
                ),
            },
            {
                dataField: 'id',
                text: 'Counter Party',
                formatter: (cellContent: string) => {
                    const process = loiFormsProcesses.find((p: LoiFormsProcess) => p.loiFormId === cellContent);
                    if (!process) return <></>;
                    const buyer = timeline.engagementProcess.buyers.find(b => b.buyerId === process.buyerId);
                    if (!buyer) return <></>;
                    return (
                        <div
                            className="link-text"
                            onClick={() => {
                                setSelectedEngagedBuyer(buyer);
                                setIsBuyerProfilePopupVisible(true);
                            }}>
                            {buyer.companyName}
                        </div>
                    );
                },
            },
            {
                dataField: 'id',
                text: 'Letter of Intent (LOI)',
                formatExtraData: isExpanded,
                formatter: (
                    cellContent: string,
                    _row: EngagementDocument,
                    _rowIndex: number,
                    isSectionExpanded: boolean
                ) => {
                    const process = loiFormsProcesses.find((p: LoiFormsProcess) => p.loiFormId === cellContent);
                    const documentDetailsId =
                        process?.isExecutedDocumentSigned && process?.executedDocumentDetailsId
                            ? process.executedDocumentDetailsId
                            : process?.documentDetailsId;
                    if (!documentDetailsId) return <></>;
                    const linkedDocument = timeline.engagementData?.documentsList?.find(d => d.id === documentDetailsId);
                    const fileName = linkedDocument?.fileName || linkedDocument?.name;
                    return (
                        <a className="doc-name" onClick={() => downloadFile({ id: documentDetailsId, fileName } as EngagementDocument)}>
                            {fileName || 'View PDF'}
                            {renderDocumentNotificationFlag(
                                `${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${cellContent}`,
                                isSectionExpanded
                            )}
                        </a>
                    );
                },
            },
            {
                dataField: 'id',
                text: 'LOI Submission Information Supplement',
                formatter: (cellContent: string) => (
                    <a className="doc-name" onClick={() => setLoiSupplementPopupLoiFormId(cellContent)}>
                        View Information
                    </a>
                ),
            },
            ...(hasPreparedSigners
                ? [
                      {
                          dataField: 'id',
                          text: 'Signers',
                          formatExtraData: loiSigningStatuses,
                          formatter: (cellContent: string) => {
                              const process = loiFormsProcesses.find(
                                  (p: LoiFormsProcess) => p.loiFormId === cellContent
                              );
                              const status =
                                  loiSigningStatuses[process?.executedDocumentDetailsId];
                              if (!status?.isPrepared || !status.signers?.length) {
                                  return <></>;
                              }
                              return <LoiSignersList signers={status.signers} />;
                          },
                      },
                  ]
                : []),
            {
                dataField: 'id',
                text: 'Actions',
                headerClasses: 'buttons-column-header',
                formatExtraData: {
                    loiSigningStatuses,
                    loiSigningDocumentId,
                    isGettingForSign: props.isGettingForSign,
                },
                formatter: (cellContent: string) => {
                    const process = loiFormsProcesses.find(
                        (p: LoiFormsProcess) => p.loiFormId === cellContent
                    );
                    const status = loiSigningStatuses[process?.executedDocumentDetailsId];
                    if (!process?.executedDocumentDetailsId || !status) {
                        return process?.isExecutedDocumentAwaitingCoOwners ? (
                            <span className="text-muted">Signed — awaiting co-owners</span>
                        ) : (
                            <></>
                        );
                    }
                    if (status.canCurrentUserSign && !isAdmin && !isBroker) {
                        return (
                            <ButtonLoader
                                key={process.executedDocumentDetailsId}
                                buttonText="Execute Document"
                                onClick={() =>
                                    startLoiSigning(process.executedDocumentDetailsId)
                                }
                                isLoading={
                                    loiSigningDocumentId === process.executedDocumentDetailsId &&
                                    props.isGettingForSign
                                }
                                loaderButtonText="Execute Document"
                                disabled={props.isGettingForSign}
                                className={'btn btn-primary execute-document-button'}
                            />
                        );
                    }
                    if (status.isCurrentUserSigningLinkSent) {
                        return <span className="text-muted">Signing link sent to your email</span>;
                    }
                    if (
                        status.currentUserMode !== null &&
                        status.isPrepared &&
                        !status.isCompleted &&
                        !status.isCurrentUserSigned &&
                        !status.isPrimaryOwnerSigned
                    ) {
                        return (
                            <span className="text-muted">
                                Waiting for the primary owner's signature
                            </span>
                        );
                    }
                    if (process.isExecutedDocumentAwaitingCoOwners) {
                        return <span className="text-muted">Signed — awaiting co-owners</span>;
                    }
                    return <></>;
                },
            },
        ];
    };

    const getDocumentColumns = () => {
        if (props.engagementDocumenstSection.isLoiSection) {
            return getLoiDocumentColumns();
        }
        return [
            props.isSelectModeEnabled && {
                dataField: 'id',
                text: 'Select',
                headerClasses: 'document-select-column-header',
                formatter: (
                    cellContent: string,
                    row: EngagementDocumentWithSelect
                ) => (
                    <input
                        key={cellContent}
                        type="checkbox"
                        checked={
                            row.isSelected ??
                            props.selectedDocumentsIds.includes(cellContent)
                        }
                        disabled={
                            !props.downloadableDocDetailsFilterCondition(
                                row as unknown as DocumentDetails
                            )
                        }
                        onChange={() => {
                            props.onDocumentSelected(cellContent);
                        }}
                    />
                ),
            },
            {
                dataField: 'name',
                text: 'Name',
                headerClasses: 'document-name-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatExtraData: isExpanded,
                formatter: (
                    cellContent: string,
                    row: EngagementDocument,
                    _rowIndex: number,
                    isSectionExpanded: boolean
                ) => {
                    const isPipDocument =
                        (row.contentType ===
                            DocumentDetailsContentType.PipOrPiq &&
                            row.source ===
                                EngagementDocumentSource.AdminUpload) ||
                        row.source === EngagementDocumentSource.BrokerUpload;
                    const isFinancialModel =
                        row.contentType ===
                        DocumentDetailsContentType.FinancialModel;
                    const showEditBtnForBroker =
                        isBroker &&
                        ((row.counterParty ===
                            EngagementDocumentCounterParty.Seller &&
                            row.type ==
                                ActionDocumentType.DocumentWithFeedback &&
                            (isPipDocument || isFinancialModel)) ||
                            row.isManualDocument);
                    const editButton = () =>
                        party === TimelineParty.VetValue ||
                        showEditBtnForBroker ||
                        isQuestionnaireSnapshot(row) ? (
                            <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="doc-edit-icon"
                                onClick={(e) => {
                                    setDocumentToEditName(row);
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                            />
                        ) : (
                            <></>
                        );
                    if (!cellContent) {
                        return 'NA';
                    }

                    // A removed document keeps its row but never exposes a
                    // downloadable link — render the name as plain text.
                    if (row.isRemoved) {
                        return (
                            <div className="doc-name-no-file">{cellContent}</div>
                        );
                    }

                    if (
                        row.type === ActionDocumentType.DocumentWithFeedback &&
                        row.contentType ===
                            DocumentDetailsContentType.PipOrPiq &&
                        row.source === EngagementDocumentSource.Questionnaire
                    ) {
                        return (
                            <a
                                className="doc-name"
                                onClick={() => {
                                    if (
                                        timeline.levelOfService ===
                                        LevelOfService.DiscountBrokerage
                                    ) {
                                        const project =
                                            timeline.engagementData.dataRequestProjects.find(
                                                (p) =>
                                                    p.id ===
                                                    row?.linkedProjectId
                                            );
                                        setLinkedProjectToView(project);
                                        setQuestionnaireDocument(row);
                                        setIsProjectItemViewPopupVisible(true);
                                    }
                                }}>
                                {cellContent}
                                {editButton()}
                                {renderDocumentNotificationFlag(
                                    `${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`,
                                    isSectionExpanded
                                )}
                            </a>
                        );
                    }

                    if (
                        !row.isPrepared ||
                        (row.type === ActionDocumentType.ForSign &&
                            row.status !== EngagementDocumentStatus.Completed)
                    ) {
                        return (
                            <div className="doc-name-no-file">
                                {cellContent}
                                {editButton()}
                                {renderDocumentNotificationFlag(
                                    `${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`,
                                    isSectionExpanded
                                )}
                            </div>
                        );
                    }

                    return (
                        <a
                            className="doc-name"
                            onClick={() => {
                                if (row.isAdminExecuted && !row.fileUrl) {
                                    setIsAdminExecutedInfoPopupVisible(true);
                                    return;
                                }
                                if (row.type === ActionDocumentType.Readonly) {
                                    getPdfUrl(row?.id);
                                } else {
                                    downloadFile(row);
                                }
                            }}>
                            {cellContent}
                            {editButton()}
                            {renderDocumentNotificationFlag(
                                `${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}.${row.id}`,
                                isSectionExpanded
                            )}
                        </a>
                    );
                },
            },
            {
                dataField: 'counterParty',
                text: 'Counter Party',
                headerClasses: 'counter-party-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (
                    cellContent: EngagementDocumentCounterParty,
                    row: EngagementDocument
                ) => {
                    const buyerId = row.engagementBuyerId;
                    if (buyerId) {
                        const selectedBuyer =
                            timeline.engagementProcess.buyers.find(
                                (f) => f.buyerId === buyerId
                            );
                        if (selectedBuyer) {
                            return (
                                <div
                                    className="link-text"
                                    onClick={() => {
                                        setSelectedEngagedBuyer(selectedBuyer);
                                        setIsBuyerProfilePopupVisible(true);
                                    }}>
                                    {selectedBuyer.companyName}
                                </div>
                            );
                        }
                    }
                    return EngagementDocumentCounterPartyOptions[cellContent];
                },
            },
            {
                dataField: 'datePosted',
                text: 'Date Posted',
                sort: !props.engagementDocumenstSection.isLetterSection,
                headerClasses: 'date-posted-column-header',
                formatter: (cellContent: Date) => (
                    <div>
                        {cellContent
                            ? moment(cellContent).format('M/D/YYYY')
                            : 'NA'}
                    </div>
                ),
            },
            {
                dataField: 'deadline',
                text: 'Deadline / Date Executed',
                sort: !props.engagementDocumenstSection.isLetterSection,
                headerClasses: 'deadline-column-header',
                formatter: (cellContent: Date) => (
                    <div>
                        {cellContent
                            ? moment(cellContent).format('M/D/YYYY')
                            : 'NA'}
                    </div>
                ),
            },
            props.isAdminView && {
                dataField: 'source',
                text: 'Document Source',
                headerClasses: 'document-source-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (cellContent: EngagementDocumentSource, row: any) =>
                    EngagementDocumentSourceOptions[cellContent],
            },
            props.isAdminView && {
                dataField: 'type',
                text: 'Type',
                headerClasses: 'type-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (cellContent: ActionDocumentType) =>
                    DocumentDetailsTypesOptions[cellContent],
            },
            {
                dataField: 'status',
                text: 'Status',
                headerClasses: 'status-column-header',
                sort: !props.engagementDocumenstSection.isLetterSection,
                formatter: (
                    cellContent: EngagementDocumentStatus,
                    row: EngagementDocument
                ) => {
                    if (row.isRemoved) {
                        return (
                            <div className="status-container removed-status">
                                Removed
                            </div>
                        );
                    }
                    let status = EngagementDocumentStatusOptions[cellContent];
                    if (row.type === ActionDocumentType.DocumentWithFeedback) {
                        if (
                            row.status ===
                            EngagementDocumentStatus.RequiresAction
                        ) {
                            status = 'Draft';
                        }
                        if (row.status === EngagementDocumentStatus.Completed) {
                            status = 'Posted';
                        }
                    } else if (
                        row.status === EngagementDocumentStatus.RequiresAction &&
                        row.type === ActionDocumentType.ForSign &&
                        row.counterParty === EngagementDocumentCounterParty.Buyer
                    ) {
                        status = 'Requires Buyer Action';
                    }
                    return (
                        <div className="status-container">
                            {status}{' '}
                            {isAdmin && row.isAdminExecuted && (
                                <span className="admin-executed-badge">
                                    Admin Executed
                                </span>
                            )}
                        </div>
                    );
                },
            },
            {
                dataField: 'status',
                text: 'Actions',
                headerClasses: 'buttons-column-header',
                sort: false,
                formatter: (
                    cellContent: EngagementDocumentStatus,
                    row: EngagementDocumentWithSelect
                ) => {
                    let masterOfdDoc: DocumentDetails;
                    let event: TimelineEvent;
                    const isMaster = row?.id == row.masterDocumentId;

                    if (isMaster) {
                        event = timeline.events.find(
                            (e) => e.linkedAction?.referenceItemId === row?.id
                        );
                    } else {
                        masterOfdDoc =
                            timeline.engagementData.documentsList.find(
                                (d) =>
                                    d?.id == row.masterDocumentId &&
                                    !!d.additionalVersionIds &&
                                    d.additionalVersionIds.includes(row?.id)
                            );
                        event = timeline.events.find(
                            (e) =>
                                e.linkedAction?.referenceItemId ===
                                masterOfdDoc?.id
                        );
                    }

                    const doc = masterOfdDoc ?? row;
                    const stillShowButtonOnCompletedEvent =
                        doc.type == ActionDocumentType.DocumentWithFeedback &&
                        (isAdmin ||
                            (!doc.isManualDocument &&
                                doc.questionnaireId &&
                                !doc.questionnaireSnapshotId));

                    const showNormalButtons = !props.isReadOnly &&
                        (stillShowButtonOnCompletedEvent ||
                            (event?.status !== TimelineEventStatus.Completed &&
                                timeline.engagementProcess.status !==
                                    EngagementProcessStatus.Completed));

                    const showQuestionnaireEditOnly =
                        !showNormalButtons &&
                        isSellerTeamMemberWithPracticeDataAndDocsPermission &&
                        row.source === EngagementDocumentSource.Questionnaire &&
                        !row.questionnaireSnapshotId &&
                        timeline.engagementProcess.status !== EngagementProcessStatus.Completed &&
                        timeline.engagementProcess.status !== EngagementProcessStatus.Suspended;

                    const canMarkDdNdaExecuted =
                        isAdmin &&
                        !row.isAdminExecuted &&
                        isBuyerDdNdaAwaitingSignature(
                            row,
                            timeline.engagementData
                        );

                    const markDdNdaExecutedButton = canMarkDdNdaExecuted ? (
                        <Button
                            onClick={() => openMarkDdNdaExecutedPopup(row)}
                            className="btn btn-primary mark-dd-nda-executed-button"
                            color="primary">
                            Mark as executed
                        </Button>
                    ) : (
                        <></>
                    );

                    return showNormalButtons ? (
                        <div className="buttons-container">
                            {getActionButtons(cellContent, row)}
                            {markDdNdaExecutedButton}
                        </div>
                    ) : showQuestionnaireEditOnly ? (
                        <div className="buttons-container">
                            {getQuestionnaireButton(row)}
                            {markDdNdaExecutedButton}
                        </div>
                    ) : canMarkDdNdaExecuted ? (
                        <div className="buttons-container">
                            {markDdNdaExecutedButton}
                        </div>
                    ) : (
                        <></>
                    );
                },
            },
            props.isAdminView && {
                dataField: 'id',
                text: '',
                headerClasses: 'remove-document-column-header',
                sort: false,
                formatter: (
                    _cellContent: string,
                    row: EngagementDocumentWithSelect
                ) =>
                    // Synthetic rows (e.g. Seller Obligation Contracts) aren't removable via this
                    // endpoint — their removal is owned by the source, so show no control.
                    !row.isRemovable ? (
                        <></>
                    ) : row.isRemoved ? (
                        <FontAwesomeIcon
                            icon={faRotateLeft}
                            className="restore-document-icon"
                            title="Restore Document"
                            onClick={() => showRestoreConfirmation(row)}
                        />
                    ) : (
                        <FontAwesomeIcon
                            icon={faTrash}
                            className="remove-document-icon"
                            title="Remove Document"
                            onClick={() => showRemoveConfirmation(row)}
                        />
                    ),
            },
        ].filter(Boolean);
    };

    const isDfmDocument = (docId: string) => {
        const doc = documents.find((d) => d?.id === docId);
        return (
            doc.type === ActionDocumentType.DocumentWithFeedback &&
            doc.contentType === DocumentDetailsContentType.FinancialModel
        );
    };

    if (props.engagementDocumenstSection.isLoiSection && engagementDocuments !== undefined && documents.length === 0) {
        return null;
    }

    return (
        <div className="document-section">
            {props.buttonsSection ? props.buttonsSection : []}
            <CollapsibleComponent
                isExpanded={isExpanded}
                onToggle={(isExpanded) => {
                    setIsExpanded(isExpanded);
                }}
                keepMounted
                header={props.engagementDocumenstSection.name}
                notificationFlag={`${NotificationFlagsCategories.MpCode}.${props.timelineId}.${NotificationFlagsCategories.EngagementDocumentsCode}.${props.engagementDocumenstSection.id}`}>
                <div
                    role="tabpanel"
                    id={`panel-${props.engagementDocumenstSection.id}`}
                    aria-labelledby={`tab-${props.engagementDocumenstSection.id}`}
                    aria-hidden="false">
                    <div className="card-body">
                        <BootstrapTable
                            striped
                            bordered
                            bootstrap4
                            remote
                            keyField="id"
                            data={rows}
                            columns={getDocumentColumns()}
                            defaultSorted={defaultSorted}
                            filter={filterFactory()}
                            headerClasses="header-vetrical-align-top"
                            pagination={undefined}
                            onTableChange={handleTableChange}
                            noDataIndication="No Documents to display"
                            rowStyle={{ height: '44px' }}
                            rowClasses={(row, index) => {
                                if (selectedDocumentId === row?.id) {
                                    return index % 2
                                        ? 'highlighted'
                                        : 'highlighted-dark';
                                }

                                return row.isRemoved ? 'removed-document' : '';
                            }}
                        />
                    </div>
                </div>
            </CollapsibleComponent>
            {isDocModalVisible ? (
                <EngagementDocumentPdfPreview
                    isVisible={isDocModalVisible}
                    pdfUrl={pdfUrl}
                    onClose={() => setIsDocModalVisible(false)}
                />
            ) : (
                []
            )}
            {documentToSign ? (
                <DocumentSignModal
                    documentId={documentToSign}
                    isVisible={!!documentToSign}
                    onClose={() => {
                        setDocumentToSign(undefined);
                        loadLoiSigningStatuses();
                    }}
                    onSign={() => {
                        setTimeout(() => {
                            loadLoiSigningStatuses();
                            fetchEngagement();
                            fetchEngagementDocuments(currentSort);
                            setDocumentToSign(undefined);
                            createNotification(
                                'Document signed successfully',
                                'success'
                            );
                        }, 2000);
                    }}
                />
            ) : (
                []
            )}

            {documentToUploadFile ? (
                <EngagementDocumentUploadModal
                    isOpen={!!documentToUploadFile}
                    onClose={() => setDocumentToUploadFile(undefined)}
                    onUpload={() => {
                        fetchEngagement();
                        fetchEngagementDocuments(currentSort);
                        setDocumentToUploadFile(undefined);
                    }}
                    documentId={documentToUploadFile}
                />
            ) : (
                []
            )}

            {manualDocumentToUpdate && (
                <ManualFileUploadPopup
                    engagementId={props.timelineId}
                    documentDetailsList={timeline.engagementData.documentsList}
                    isVisible={!!manualDocumentToUpdate}
                    setIsVisible={() => setManualDocumentToUpdate(undefined)}
                    documentsSections={
                        timeline.engagementData.documentSectionsList
                    }
                    sectionsModalMode={'external-modal'}
                    documentId={manualDocumentToUpdate}
                    onSaved={props.reloadDocuments}
                />
            )}

            {isProjectItemViewPopupVisible && linkedProjectToView ? (
                <ProjectItemViewPopup
                    isVisible={isProjectItemViewPopupVisible}
                    setIsVisible={(visible: boolean) => {
                        setIsProjectItemViewPopupVisible(visible);
                        if (!visible) {
                            setLinkedProjectToView(undefined);
                            setQuestionnaireDocument(undefined);
                        }
                    }}
                    questionnaireDocument={questionnaireDocument}
                    engagementStartDate={timeline.engagementProcess.startDate}
                    linkedProject={linkedProjectToView}
                    engagementId={props.timelineId}
                />
            ) : (
                <></>
            )}
            {isBuyerProfilePopupVisible ? (
                <BuyerProfilePreviewPopup
                    buyerId={selectedEngagedBuyer.buyerId}
                    close={closeBuyerProfile}
                />
            ) : (
                <></>
            )}
            {isApprovalPopupVisible && (
                <ConfirmationModal
                    header={documentApprovalPopupHeader}
                    isVisible={isApprovalPopupVisible}
                    setIsVisible={setIsApprovalPopupVisible}
                    confirmationText={
                        isDfmDocument(documentWithFeedbackId) ||
                        isMultiDocumentApproval
                            ? multiDocAndDfmBody
                            : singleDocBody
                    }
                    params={''}
                    onConfirm={() =>
                        confirmDocumentWithFeedback(documentWithFeedbackId)
                    }
                    nextButtonText="Confirm Approval"
                    cancelButtonText="Cancel & Close"
                    isLoading={isDocConfirming}
                />
            )}

            {isRemoveConfirmationVisible && (
                <ConfirmationModal
                    header="Remove Document"
                    isVisible={isRemoveConfirmationVisible}
                    setIsVisible={setIsRemoveConfirmationVisible}
                    confirmationText={`Are you sure you want to remove "${documentToRemove?.name}"? The document will be marked as Removed and its file will no longer be available. You can restore it later.`}
                    params={''}
                    onConfirm={handleRemoveDocument}
                    onCancel={() => setDocumentToRemove(undefined)}
                    nextButtonText="Yes, Remove"
                    cancelButtonText="Cancel"
                    isLoading={isProcessingRemove}
                    closeOnConfirm={false}
                    isConfirmationDanger={true}
                />
            )}

            {isRestoreConfirmationVisible && (
                <ConfirmationModal
                    header="Restore Document"
                    isVisible={isRestoreConfirmationVisible}
                    setIsVisible={setIsRestoreConfirmationVisible}
                    confirmationText={`Are you sure you want to restore "${documentToRestore?.name}"? The document will return to its previous status and its file will be available again.`}
                    params={''}
                    onConfirm={handleRestoreDocument}
                    onCancel={() => setDocumentToRestore(undefined)}
                    nextButtonText="Yes, Restore"
                    cancelButtonText="Cancel"
                    isLoading={isProcessingRestore}
                    closeOnConfirm={false}
                />
            )}

            {documentToEditName && (
                <EditDocumentNamePopup
                    document={documentToEditName}
                    engagementId={props.timelineId}
                    isVisible={!!documentToEditName}
                    onClose={() => setDocumentToEditName(undefined)}
                    onRenamed={() => fetchEngagementDocuments(currentSort)}
                />
            )}
            {loiSupplementPopupLoiFormId && (
                <LoiSubmissionInformationSupplementPopup
                    loiFormId={loiSupplementPopupLoiFormId}
                    engagementId={props.timelineId}
                    isProcessCompleted={(timeline.engagementData?.loiFormsProcesses ?? []).some(
                        (p: LoiFormsProcess) =>
                            p.loiFormId === loiSupplementPopupLoiFormId &&
                            isLoiProcessCompleted(p)
                    )}
                    onClose={() => setLoiSupplementPopupLoiFormId(null)}
                />
            )}

            {isMarkExecutedPopupVisible && (
                <MarkDdNdaExecutedPopup
                    isVisible={isMarkExecutedPopupVisible}
                    onClose={closeMarkDdNdaExecutedPopup}
                    onConfirm={handleMarkDdNdaExecuted}
                    isLoading={isMarkingDdNdaExecuted}
                />
            )}

            {isAdminExecutedInfoPopupVisible && (
                <ConfirmationModal
                    header="Document Marked as Executed"
                    isVisible={isAdminExecutedInfoPopupVisible}
                    setIsVisible={setIsAdminExecutedInfoPopupVisible}
                    confirmationText="This DD NDA was marked as executed by an administrator; no document file is attached."
                    params={''}
                    onConfirm={() => setIsAdminExecutedInfoPopupVisible(false)}
                    nextButtonText="OK"
                    hideCancelButton
                />
            )}
        </div>
    );
};

export default SellersEngagementDocumentsSection;
